// extracted by mini-css-extract-plugin
export default {"outer":"outer___esIs2","lds-ripple":"lds-ripple___ONcCm"};